import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import store from '../store/store'
import FullSearch from "./FullSearch.jsx"

document.addEventListener('DOMContentLoaded', () => {
  const searchWrapper = document.querySelector('[data-search-grid]')
  if(searchWrapper) {
    const searchRoot = createRoot(searchWrapper)
    searchRoot.render(
      <Provider store={store}>
        <FullSearch />
      </Provider>)
  }
})